export default __webpack_public_path__ + "6207107bff9ac100959a84bc7d42c6e2d69132ebb8610145047cc675797e43dd.png";